export const MY_PICTURES_PHOTOS = [
  {
    id: 'nostalgia-01',
    filename: 'nostalgia-01.jpg',
    title: 'Summer Road Trip',
    date: 'June 18, 2004',
    description: 'Disposable camera scan from a family highway stop.',
    type: 'JPEG Image',
    size: '482 KB',
    dimensions: '1600 x 1200',
    src: '/photos/nostalgia/nostalgia-01.jpg',
  },
  {
    id: 'nostalgia-02',
    filename: 'nostalgia-02.jpg',
    title: 'Mall Arcade Night',
    date: 'November 7, 2006',
    description: 'Weekend photos after school near the arcade entrance.',
    type: 'JPEG Image',
    size: '536 KB',
    dimensions: '1600 x 1200',
    src: '/photos/nostalgia/nostalgia-02.jpg',
  },
  {
    id: 'nostalgia-03',
    filename: 'nostalgia-03.jpg',
    title: 'Birthday Sleepover',
    date: 'March 3, 2007',
    description: 'Old point-and-shoot photo from a living room sleepover.',
    type: 'JPEG Image',
    size: '501 KB',
    dimensions: '1600 x 1200',
    src: '/photos/nostalgia/nostalgia-03.jpg',
  },
];

export default MY_PICTURES_PHOTOS;
